import { tv } from 'tailwind-variants';

/** Shared dashboard tab button — used by analytics and sic variants. */
export const dashboardSegmentTab = tv({
  base: 'rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
  variants: {
    active: {
      /* Use on-primary — dark chrome uses a soft zinc fill; hardcoded white fails contrast. */
      true: 'bg-[var(--color-an-primary)] text-[color:var(--color-an-on-primary)]',
      false:
        'bg-[var(--color-an-surface)] text-[var(--color-an-text-muted)] hover:text-[var(--color-an-text)]',
    },
  },
});

/** @deprecated Use `dashboardSegmentTab` — alias kept for existing imports. */
export const analyticsSegmentTab = dashboardSegmentTab;

/** Legacy full-width tab bar (dev centre / success-incident centre). */
export const sicSegmentTab = dashboardSegmentTab;

export const analyticsSegmentTabList = tv({
  base: 'mb-4 flex flex-wrap gap-1',
});

export const sicSegmentTabList = analyticsSegmentTabList;

/** Tier-2 analytics sub-tab list (bordered row under group tabs). */
export const analyticsSubTabList = tv({
  base: 'mb-3 flex flex-wrap gap-1 border-b border-[var(--color-an-border)] pb-2',
});

/** Tier-2 analytics sub-tab — soft active (distinct from tier-1 group tabs). */
export const analyticsSubTab = tv({
  base: 'rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
  variants: {
    active: {
      true: 'bg-[var(--color-an-primary-soft)] text-[var(--color-an-primary)] ring-1 ring-[var(--color-an-primary)]/30',
      false:
        'text-[var(--color-an-text-muted)] hover:text-[var(--color-an-text)] hover:bg-[var(--color-an-surface)]',
    },
  },
});

/** Overflow "+N další" trigger for SegmentTabsOverflow (&lt;1024px). */
export const analyticsSubTabOverflowTrigger = tv({
  base: 'rounded-md px-2 py-1.5 text-sm font-medium text-[var(--color-an-text-muted)] hover:bg-[var(--color-an-surface)]',
});
